import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CedulaEcuadorValidators {
  static Validar(error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null;
      }
      if (control.value.length !== 10) {
        return error;
      }
      if ((parseInt(control.value[0], 10) * 10 + parseInt(control.value[1], 10)) < 0 ||
        (parseInt(control.value[0], 10) * 10 + parseInt(control.value[1], 10)) > 24) {
        return error;
      }

      let coeficiente = 0;
      for (let i = 0; i < control.value.length - 1; i++) {
        if (i % 2 === 0) {
          let x = parseInt(control.value[i], 10) * 2;
          if (x >= 10) {
            x = x - 9;
          }
          coeficiente = coeficiente + x;
        } else {
          coeficiente = coeficiente + parseInt(control.value[i], 10);
        }
      }
      const coenf = (coeficiente + 10) - parseInt(coeficiente.toString()[1], 10);
      if ((coenf - coeficiente) !== parseInt(control.value[9], 10) && (coenf - coeficiente) !== 10) {
        return error;
      }

      return null;
    };
  }
}


export function formatDate(DateIn: string | undefined | null | Date) {

  try {
    const dateObject = DateIn ? new Date(DateIn) : null;
    const formattedDate = dateObject
      ? dateObject.toISOString().split('T')[0]
      : null;
    return formattedDate;
  } catch (error) {
    return null;
  }
}
